export type WorkScope = {
  id: number | string
  isSystem: boolean
  name: string
  options: WorkScopeOption[],
  selectedOptionId: number | string | null,
  reportTypeId: ReportTypes
}

export type WorkScopeOption = {
  id: number | string
  isSystem: boolean,
  defaultName: string,
  defaultDescription: string
  name: string,
  description: string
}

export enum ReportTypes {
  Default = 1,
  Bank = 2,
  Commercial = 3,
  FairValue = 4
}